import Home from "../Pages/Home/Home";

export const routes = [
  {
    path: "/",
    component: Home,
  },
];
